import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import * as S from './Modal.sc';

type Modal = {
  children: React.ReactNode;
  onClose: () => void;
  fullScreen?: boolean;
  section: Section;
  show: boolean;
  title?: string;
};

const Modal = ({
  onClose,
  children,
  fullScreen,
  section,
  show,
  title,
}: Modal) => {
  const [isBrowser, setIsBrowser] = useState(false);

  const modalWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsBrowser(true);

    document.body.style.overflow = show ? 'hidden' : 'unset';

    function handleClickOutside(event) {
      if (
        modalWrapperRef.current &&
        !modalWrapperRef.current.contains(event.target)
      ) {
        onClose();
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [modalWrapperRef, onClose, show]);

  const handleCloseClick = (e) => {
    e.preventDefault();
    onClose();
  };

  const modalContent = show ? (
    <S.Overlay>
      <S.Wrapper fullScreen={fullScreen || false} ref={modalWrapperRef}>
        <S.ModalBox>
          <S.Header>
            <S.CloseButton onClick={handleCloseClick} />
            {title && <S.Title>{title}</S.Title>}
          </S.Header>
          <S.Body>{children}</S.Body>
        </S.ModalBox>
      </S.Wrapper>
    </S.Overlay>
  ) : null;

  if (isBrowser) {
    return ReactDOM.createPortal(
      modalContent,
      document.getElementById('modal')
    );
  } else {
    return null;
  }
};

export default Modal;
